"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconSpellCheck.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSpellCheck = function IconSpellCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.5 13.031-6.5 6.5-3-3M5.238 8.375c.442-.36 1.266-.613 1.813-.46.547.151 1.074.483 1.074 1.585v3.125",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.98 9.84c-.683.035-1.816-.016-2.566.797-.586.636-.492 2.133.95 2.133.874 0 1.616-.883 1.616-.883m2.372-6.192v6.766c.976.488 2.101.422 2.789-.14.765-.626.765-1.348.765-2.137 0-1.418-.82-2.125-1.465-2.25-1.441-.286-2.09.503-2.09.503m5.301 1.883c0-1.906.883-2.433 1.86-2.433.972 0 1.347.691 1.347.691m-3.207 1.742c0 1.907.883 2.438 1.86 2.438.972 0 1.347-.695 1.347-.695",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })));
};

IconSpellCheck.displayName = "IconSpellCheck";
var _default = IconSpellCheck;
exports["default"] = _default;
//# sourceMappingURL=IconSpellCheck.js.map